export default __webpack_public_path__ + "static/media/HexapodMain@2x.09d6eb99.png";